(() => {
  'use strict';

  if (window.__cartDiscountBarBooted) return;
  window.__cartDiscountBarBooted = true;

  const DISCOUNT_TIERS = [
    { minUniqueProducts: 4, percent: 5 },
    { minUniqueProducts: 7, percent: 10 },
    { minUniqueProducts: 10, percent: 15 }
  ];

  const FINAL_ACCESSORY_THRESHOLD =
    DISCOUNT_TIERS[DISCOUNT_TIERS.length - 1].minUniqueProducts - 1;

  const ROOT_PATH = window.Shopify?.routes?.root || '/';

    let accessoryProductIds = null;
  let destockProductIds = null;
  let refreshTimer = null;
  let refreshInProgress = false;
  let refreshQueued = false;

  function loadAccessorySet() {
    if (accessoryProductIds) return accessoryProductIds;

    const node =
      document.getElementById('accessory-product-set');

    if (!node) {
      accessoryProductIds = new Set();
      return accessoryProductIds;
    }

    try {
      const ids =
        JSON.parse(node.textContent || '[]');

      accessoryProductIds =
        new Set(ids.map(Number));
    } catch (_) {
      accessoryProductIds = new Set();
    }

    return accessoryProductIds;
  }

  function loadDestockSet() {
    if (destockProductIds) return destockProductIds;

    const node =
      document.getElementById('destock-product-set');

    if (!node) {
      destockProductIds = new Set();
      return destockProductIds;
    }

    try {
      const ids =
        JSON.parse(node.textContent || '[]');

      destockProductIds =
        new Set(ids.map(Number));
    } catch (_) {
      destockProductIds = new Set();
    }

    return destockProductIds;
  }

  function hasBrasero(cartItems) {
    const excludedIds =
      loadDestockSet();

    return cartItems.some(item => {
      const productId =
        Number(item.product_id);

      if (excludedIds.has(productId)) {
        return false;
      }

      const title =
        String(
          item.product_title ||
          item.title ||
          ''
        ).toLowerCase();

      const productType =
        String(
          item.product_type ||
          ''
        ).toLowerCase();

      return (
        title.includes('brasero') ||
        productType.includes('brasero')
      );
    });
  }

  function selectedUniqueAccessoryCount(cartItems) {
    const accessoryIds =
      loadAccessorySet();

    const uniqueIds =
      new Set();

    cartItems.forEach(item => {
      const productId =
        Number(item.product_id);

      if (accessoryIds.has(productId)) {
        uniqueIds.add(productId);
      }
    });

    return uniqueIds.size;
  }

  function discountTierInfo(
    accessoryCount,
    braseroPresent
  ) {
    if (!braseroPresent) {
      return {
        count: accessoryCount,
        accessoryCount,
        current: null,
        next: null
      };
    }

    const totalUniqueProducts =
      accessoryCount + 1;

    let current = null;
    let next = null;

    DISCOUNT_TIERS.forEach(tier => {
      if (
        totalUniqueProducts >=
        tier.minUniqueProducts
      ) {
        current = tier;
      } else if (!next) {
        next = tier;
      }
    });

    return {
      count: totalUniqueProducts,
      accessoryCount,
      current,
      next
    };
  }

  function progressPercent(accessoryCount) {
    if (
      FINAL_ACCESSORY_THRESHOLD <= 0
    ) {
      return 0;
    }

    return Math.max(
      0,
      Math.min(
        100,
        (
          accessoryCount /
          FINAL_ACCESSORY_THRESHOLD
        ) * 100
      )
    );
  }

  function buildMessage(
    root,
    accessoryCount,
    braseroPresent
  ) {
    if (!braseroPresent) {
      if (accessoryCount >= 3) {
        return (
          root.dataset.noBraseroDone ||
          ''
        );
      }

      const remaining =
        Math.max(
          1,
          3 - accessoryCount
        );

      const template =
        remaining === 1
          ? (
              root.dataset.noBraseroSingle ||
              ''
            )
          : (
              root.dataset.noBraseroMulti ||
              ''
            );

      return template.replace(
        '[count]',
        remaining
      );
    }

    const info =
      discountTierInfo(
        accessoryCount,
        braseroPresent
      );

    if (!info.next) {
      return (
        root.dataset.allUnlocked ||
        ''
      );
    }

    const nextAccessoryThreshold =
      info.next.minUniqueProducts - 1;

    const remaining =
      nextAccessoryThreshold -
      accessoryCount;

    const template =
      remaining === 1
        ? (
            root.dataset.almost ||
            ''
          )
        : (
            root.dataset.progress ||
            ''
          );

    return template
      .replace(
        '[count]',
        remaining
      )
      .replace(
        '[percent]',
        info.next.percent
      );
  }

  function renderBar(root, cartItems) {
    const braseroPresent =
      hasBrasero(cartItems);

    const accessoryCount =
      selectedUniqueAccessoryCount(
        cartItems
      );

    const pct =
      progressPercent(
        accessoryCount
      );

    const messageEl =
      root.querySelector(
        '[data-discount-message]'
      );

    const fillEl =
      root.querySelector(
        '[data-discount-fill]'
      );

    const milestonesEl =
      root.querySelector(
        '[data-discount-milestones]'
      );

    if (messageEl) {
      messageEl.textContent =
        buildMessage(
          root,
          accessoryCount,
          braseroPresent
        );
    }

    if (fillEl) {
      fillEl.style.width =
        pct + '%';
    }

    if (milestonesEl) {
      milestonesEl.innerHTML =
        DISCOUNT_TIERS.map(
          (tier, index) => {
            const threshold =
              tier.minUniqueProducts - 1;

            const leftPct =
              FINAL_ACCESSORY_THRESHOLD > 0
                ? (
                    threshold /
                    FINAL_ACCESSORY_THRESHOLD
                  ) * 100
                : 0;

            const reached =
              braseroPresent &&
              accessoryCount >=
                threshold;

            const isLast =
              index ===
              DISCOUNT_TIERS.length - 1;

            const alignStyle =
              isLast
                ? 'transform:translate(-100%,-50%);'
                : 'transform:translate(-50%,-50%);';

            return `
              <span
                class="cart-discount-bar__milestone${reached ? ' is-reached' : ''}"
                data-milestone="${threshold}"
                style="left:${leftPct}%;${alignStyle}"
              >
                -${tier.percent}%
              </span>
            `;
          }
        ).join('');
    }
  }

  function getRoots() {
    return Array.from(
      document.querySelectorAll(
        '[data-cart-discount-bar]'
      )
    );
  }

  async function fetchCart() {
    const response =
      await fetch(
        `${ROOT_PATH}cart.js`,
        {
          headers: {
            Accept: 'application/json'
          }
        }
      );

    if (!response.ok) {
      throw new Error(
        'Cart request failed'
      );
    }

    return response.json();
  }

  async function refresh() {
    if (refreshInProgress) {
      refreshQueued = true;
      return;
    }

    const roots = getRoots();

    if (!roots.length) {
      return;
    }

    refreshInProgress = true;
    refreshQueued = false;

    try {
      const cart =
        await fetchCart();

      const currentRoots =
        getRoots();

      currentRoots.forEach(root => {
        renderBar(
          root,
          cart.items || []
        );
      });
    } catch (_) {
    } finally {
      refreshInProgress = false;

      if (refreshQueued) {
        refreshQueued = false;
        queueRefresh(50);
      }
    }
  }

  function queueRefresh(
    delay = 100
  ) {
    clearTimeout(
      refreshTimer
    );

    refreshTimer =
      setTimeout(
        () => refresh(),
        delay
      );
  }

  const originalFetch =
    window.fetch;

  window.fetch =
    function (...args) {
      const url =
        typeof args[0] === 'string'
          ? args[0]
          : (
              args[0]?.url ||
              ''
            );

      const result =
        originalFetch.apply(
          this,
          args
        );

      const isCartMutation = [
        '/cart/add',
        '/cart/change',
        '/cart/update',
        '/cart/clear'
      ].some(path =>
        url.includes(path)
      );

      const isCartDrawerRefresh =
        url.includes(
          'sections=cart-drawer'
        ) ||
        url.includes(
          'sections%3Dcart-drawer'
        );

      if (
        isCartMutation ||
        isCartDrawerRefresh
      ) {
        result
          .then(response => {
            if (response.ok) {
              queueRefresh(150);
            }
          })
          .catch(() => {});
      }

      return result;
    };

  document.addEventListener(
    'cart:updated',
    () => queueRefresh()
  );

  document.addEventListener(
    'cart:refresh',
    () => queueRefresh()
  );

  document.addEventListener(
    'cart-rewards:updated',
    () => queueRefresh()
  );

  document.addEventListener(
    'cart-rewards:sync-end',
    () => queueRefresh()
  );

  window.addEventListener(
    'pageshow',
    event => {
      if (event.persisted) {
        queueRefresh();
      }
    }
  );

  const observer =
    new MutationObserver(
      mutations => {
        const shouldRefresh =
          mutations.some(mutation => {
            return Array.from(
              mutation.addedNodes || []
            ).some(node => {
              if (
                node.nodeType !== 1
              ) {
                return false;
              }

              return (
                node.matches?.(
                  '[data-cart-discount-bar], cart-drawer'
                ) ||
                node.querySelector?.(
                  '[data-cart-discount-bar], cart-drawer'
                )
              );
            });
          });

        if (shouldRefresh) {
          queueRefresh(100);
        }
      }
    );

  function observeDocument() {
    if (!document.body) return;

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }

    function init() {
    loadAccessorySet();
    loadDestockSet();
    refresh();
    observeDocument();
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      { once: true }
    );
  } else {
    init();
  }
})();